<template>
    <div>

        <div class="container-fluid lead-screen section">

            <lead-information
                    :carriers="carriers"
                    :details="leadDetails"
                    @leadUpdate="leadUpdate"
                    @leadCarrierUpdate="fetchLeadCarriers"
            ></lead-information>

            <ul class="nav">
                <li class="nav-item">
                    <a class="nav-link" :class="{active: activeTab == 'details'}" @click.prevent="setActiveTab('details')" href="#">Details</a>
                </li>

                <li class="nav-item" v-for="carrier in leadCarriers ">

                    <a class="nav-link" :class="{active: activeTab == carrier.leadCarrier_id}" @click.prevent="setActiveTab(carrier)" href="#">{{carrier.carrier_name}}</a>
                </li>
            </ul>
        </div>
          <div class="col-holder" v-show="activeTab == 'details'">
            <div class="row">
                <div class="col-12 col-xl-6">
                    <lead-locations
                        :lead_id="$route.params.lead_id"
                        @leadCarrierUpdate="fetchLeadCarriers"
                    >
                    </lead-locations>
                </div>
                <div class="col-12 col-xl-6">
                    <lead-contacts
                            :details="leadDetails"
                            :leadContacts="leadContacts"
                            @leadContactsUpdate="leadContactsUpdate"
                            @leadContactsDelete="leadContactsDelete"
                    >
                    </lead-contacts>

                    <lead-notes
                        :lead_id="$route.params.lead_id"
                        :details="leadDetails"
                    >
                    </lead-notes>

                    <lead-files
                        :details="leadDetails"
                    ></lead-files>
                </div>

            </div>
        </div>

        <div class="col-holder" v-show="activeTab != 'details'">
            <div class="row">
                <div class="col-12 col-xl-6">
                    <lead-carrier-notes
                            v-if="activeTab != 'details'"
                            :leadCarrier_id="leadCarrier_id"
                            :details="leadDetails"
                            :carrier_id="carrier_id"
                    >
                    </lead-carrier-notes>



                    <!--<lead-carrier-products-->
                        <!--:carriers="carriers"-->
                        <!--:details="leadDetails"-->
                        <!--:leadCarrier_id="leadCarrier_id"-->
                        <!--:carrierProducts="carrierProducts"-->
                    <!--&gt;</lead-carrier-products>-->
                    <!--<lead-quotes-->
                        <!--v-if="activeCarrier.leadCarrier_id"-->
                        <!--:details="leadDetails"-->
                        <!--:carrier="activeCarrier"-->
                        <!--:leadCarrier_id="leadCarrier_id"-->
                    <!--&gt;-->
                    <!--</lead-quotes>-->
                </div>
                <div class="col-12 col-xl-6">
                    <lead-carrier-files
                        v-if="activeTab != 'details'"
                        :details="leadDetails"
                        :leadCarrier_id="leadCarrier_id"
                    ></lead-carrier-files>
                </div>

            </div>
            <div class="row">
                <div class="col-12">
                    <button style="margin: 10px auto; display: block;" @click="leadCarrierCreateAccount(leadCarrier_id)" class="btn btn-lg btn-secondary">Create Account</button>
                </div>
            </div>
        </div>




    </div>

</template>
<script type="text/babel">
    import LeadInformation from './LeadInformation.vue';

    import LeadFiles from './LeadFiles.vue';
    import LeadCarrierFiles from './LeadCarrierFiles.vue';
    import LeadContacts from './LeadContacts.vue';
    import LeadLocations from './LeadLocations.vue';
    import LeadNotes from './LeadNotes.vue';
    import LeadCarrierNotes from './LeadCarrierNotes.vue';
    import LeadCarrierProducts from './LeadCarrierProducts.vue';
    import LeadQuotes from './LeadQuotes.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';

    export default {
        name: "ViewLead",
        data: function(){
            return {
                lead_id: '',
                activeTab: 'details',
                leadCarrier_id: '',
                userRoles: [],
                carriers:[],
                carrierProducts:[],
                leadCarriers: [],
                leadDetails: {},
                leadFiles:[],
                leadContacts:[],
                leadNotes:[],
                notepage: 0,
                carrier_id: null,
                activeCarrier: {},
                matchesPagination:{
                    offset: 0,
                    limit: 20
                }
            }
        },
        components:{
            LeadInformation,
            LeadFiles,
            LeadCarrierFiles,
            LeadContacts,
            LeadLocations,
            LeadCarrierProducts,
            LeadNotes,
            LeadCarrierNotes,
            DropdownConfirmation,
            LeadQuotes

        },
        created(){
            this.lead_id = this.$route.params.lead_id;
            this.fetchData();
            this.fetchCarriers();
            this.fetchLeadCarriers();
        },
        computed:{

            canApprove(){

                var canApprove = this.$store.getters.getUserRoles.filter(function(role){
                    return role.name == "leads"
                }).map(function(role){
                    return role.rolesPermissions.filter(function(rp){
                        return rp.rolePermission_id == 10
                    }).map(function(rp){
                        return rp.state;
                    })[0];
                })[0];

                return canApprove;

            }
        },
        methods:{
            leadCarrierCreateAccount(leadCarrier_id){
                this.$send(this, 'leadCarrierCreateAccount',  {leadCarrier_id: leadCarrier_id }).then(r => {
                    this.leadDetails = r.leadDetails;
                });
            },
            setActiveTab(active){

                if(active == 'details'){
                    this.activeTab = 'details';
                    this.leadCarrier_id = null;
                    this.carrierProducts = [];
                } else {
                    console.log(active);
                    this.activeTab = active.leadCarrier_id;
                    this.leadCarrier_id =  active.leadCarrier_id;
                    this.activeCarrier = active;
                    this.fetchCarrierProducts(active.carrier_id);
                }

            },
            fetchLeadCarriers(){
                this.$send(this, 'leadCarriers', {
                    lead_id: this.lead_id
                }).then(r => {
                    this.leadCarriers = r.leadCarriers
                });
            },
            fetchData(onlyData){

                this.$send(this, 'leadDetails',  {lead_id: this.lead_id}).then(r => {
                    this.leadDetails = r.leadDetails;

                    if(!onlyData){
                        //this.fetchCarrierProducts();
                        //  this.fetchleadProducts();
//                        this.fetchLeadFiles();
                        this.fetchLeadContacts();
//                        this.fetchlLeadNotes();
                        // this.fetchleadUsers();

                    }
                });

            },
            fetchCarrierProducts(carrier_id){
                this.$send(this, 'carrierProducts',  {
                    carrier_id: carrier_id
                }).then(r => {
                    this.carrierProducts = r.carrierProducts;
                });
            },
            approveLead(status){
                this.leadUpdate({approved: status});
            },
            leadUpdate(data){

                data.lead_id = this.$route.params.lead_id;
                this.$send(this, 'leadUpdate',  data).then(r => {
                    this.fetchData(true);
                });

            },

            leadContactsUpdate(data){
                var _this = this;

                data.lead_id = this.$route.params.lead_id;
                var fn = (data.leadContact_id)? 'leadContactsUpdate': 'leadContactsUpdate';

                this.$send(this, fn, data).then(r => {
                    this.fetchLeadContacts();
                });

            },

            leadContactsDelete(data){
                var _this = this;
                data.lead_id = this.$route.params.lead_id;

                this.$send(this, 'leadContactsDelete', data).then(r => {
                    this.fetchLeadContacts()
                });
            },

            fetchLeadContacts(){

                this.$send(this, 'leadContacts',  this.$route.params.lead_id).then(r => {
                    console.log(r);

                    this.leadContacts = r.leadContacts || [];
                });

            },

            fetchLeadNotes(){


                this.$send(this, 'leadNotes',  {
                    lead_id: this.$route.params.lead_id
                }).then(r => {
                    this.leadNotes = r.leadNotes;
                    this.notepage = r.count;
                });
            },

            fetchCarriers(){

                this.$send(this, 'carriers').then(r => {
                    this.carriers = r.carriers;
                });
            }
        },
        watch:{
            carrier_id(){
                this.fetchCarrierProducts();
            }
        }
    }

</script>
<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }
    .container-fluid.col-holder{
        background: none;
        box-shadow: none;
        padding: 0;
    }
    .lead-screen .nav{
    }
    .lead-screen .nav{
        border-top: 1px solid #e2e2e2;
    }


    .lead-screen a.nav-link {
        padding: 10px 20px;
        background: #e3eaf1;
        margin: 10px 5px 0;
        -webkit-border-radius:4px;
        -moz-border-radius:4px;
        border-radius:4px;
        font-weight: 700;
    }

    .lead-screen a.nav-link.active {
        background:#325482;
        color: white;
    }



</style>



// WEBPACK FOOTER //
// View.vue?3c46315d